import { render, staticRenderFns } from "./fattureElettroniche.vue?vue&type=template&id=0ffe80b9&"
import script from "./fattureElettroniche.vue?vue&type=script&lang=js&"
export * from "./fattureElettroniche.vue?vue&type=script&lang=js&"
import style0 from "./fattureElettroniche.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports